import { Outlet } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Footer from "./components/Footer/Footer";
import Navigationbar from "./components/Navigationbar/Navigationbar";
import SEO from "./components/SEO/SEO";

function App() {
  return (
    <HelmetProvider>
      <SEO />
      <Navigationbar />
      <Outlet />
      <Footer />
    </HelmetProvider>
  );
}

export default App;
